export const settingsCacheKey = "/companies/:company_id/settings" as const;
export const contactInformationCacheKey = "/companies/:company_id/contact_information" as const;
export const notificationsCacheKey = "/companies/:company_id/notification_preferences/list" as const;
export const securitySettingsCacheKey = "/companies/:company_id/security_settings" as const;
export const linkShorteningDomainsCacheKey = "/companies/:company_id/link_shortening_domains" as const;
export const timezoneOptionsCacheKey = "/companies/:company_id/time_zone_options" as const;
export const audienceSyncAllotmentsCacheKey = "/companies/:company_id/audience_sync_allotments" as const;
